<button
  type="button"
  class="btn btn-link popOver"
  container="body"
  popoverClass="dcPopover"
  #p="ngbPopover"
  [ngbPopover]="popContent"
  triggers="manual"
  (click)="p.open()"
  [title]="label ? label : ''"
  [popoverTitle]="label ? label : null"
></button>
<ng-template #popContent>
  <div [innerHtml]="body"></div>
</ng-template>
